// Portée de l'appareil: une société + un compte. Les données locales ne sont
// jamais partagées entre deux comptes et disparaissent à la déconnexion.
import { appState, db, definirPorteeFile } from '../db';
import { oublierFormes, oublierFraicheur } from './store';
import { definirDonneesLocalesPretes } from './arrierePlan';

const CLE_PORTEE = 'porteeLocale';

export const calculerPortee = (utilisateur) => {
  if (!utilisateur) return null;
  const societe = utilisateur.org_id || utilisateur.organization_id || utilisateur.organization?.id || 'sans-societe';
  const compte = utilisateur.user_id || utilisateur.id || utilisateur.email || 'inconnu';
  return `${societe}:${compte}`;
};

/** Tables du modèle de lecture et des anciens caches: tout sauf la file d'envois. */
export async function effacerLectureLocale() {
  const tables = db.tables.filter((table) => table.name !== 'syncQueue');
  await db.transaction('rw', tables, async () => {
    for (const table of tables) await table.clear();
  });
  oublierFormes();
  oublierFraicheur();
  definirDonneesLocalesPretes(false);
}

/** À la connexion ou à la restauration de session. */
export async function activerPortee(utilisateur) {
  const portee = calculerPortee(utilisateur);
  if (!portee) return null;
  definirPorteeFile(portee);
  try {
    const ancienne = await appState.get(CLE_PORTEE);
    if (ancienne && ancienne !== portee) await effacerLectureLocale();
    await appState.set(CLE_PORTEE, portee);
  } catch (erreur) {
    console.warn('Local scope check failed:', erreur);
  }
  try {
    if (typeof navigator !== 'undefined' && navigator.storage?.persist) navigator.storage.persist();
  } catch (erreur) {
    // Le navigateur décide: sans effet visible.
  }
  return portee;
}

/** À la déconnexion: la lecture locale est effacée, les envois en attente sont gardés. */
export async function quitterPortee() {
  definirPorteeFile(null);
  try {
    await effacerLectureLocale();
  } catch (erreur) {
    console.warn('Local data wipe failed:', erreur);
  }
}
